import { render, staticRenderFns } from "./radio-score.vue?vue&type=template&id=60c57d73&scoped=true&"
import script from "./radio-score.vue?vue&type=script&lang=ts&"
export * from "./radio-score.vue?vue&type=script&lang=ts&"
import style0 from "./radio-score.vue?vue&type=style&index=0&id=60c57d73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c57d73",
  null
  
)

export default component.exports